import services from '@/config/services'
import moment from 'moment'

export default class FattureService{
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
  }

  getMesiDaFatturare(){
    let items = []
    let totalItems = 0

    items = Array.from(Array(24).keys()).map(month => moment().subtract(month, 'months').startOf('month').format('YYYY-MM-DD'))
    totalItems = items.length

    return Promise.resolve({
      items,
      total: totalItems
    })
  }

  async makeSimulation(config){
    let items = []
    let totalItems = 0

    const url = `${this.baseUrl}/clienti/fatture/genera/simulazione`

    try {
      let res = await this.http.post(url, {data: config})
      res = res.data
      console.log('makeSimultations', res)

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems
      }
    }
  }

  async makeInvoices(config){
    let items = []
    let totalItems = 0

    const url = `${this.baseUrl}/clienti/fatture/genera`

    try {
      let res = await this.http.post(url, {data: config})
      res = res.data
      console.log('makeInvoices', res)

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems
      }
    }
  }
}
